import getDeviceId from '@helpers/auth/getDeviceId'

export default function useAmplitude() {
  const deviceId = getDeviceId()
  const deviceIdNumber =
    deviceId
      ?.split('')
      .map(i => i.charCodeAt(0))
      .reduce((a, b) => a + b, 0) % 2
  return deviceIdNumber === 0
}
